import React, { createContext, useContext, useEffect, useState } from 'react';

const AccessibilityContext = createContext();

export const useAccessibility = () => {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
};

export const AccessibilityProvider = ({ children }) => {
  const [textScale, setTextScale] = useState(() => {
    const savedScale = localStorage.getItem('textScale');
    return savedScale ? parseFloat(savedScale) : 1;
  });

  useEffect(() => {
    document.documentElement.style.fontSize = `${textScale * 16}px`;
    localStorage.setItem('textScale', textScale.toString());
  }, [textScale]);

  const increaseTextSize = () => {
    setTextScale(prev => Math.min(prev + 0.1, 1.5)); // Max 150%
  };

  const decreaseTextSize = () => {
    setTextScale(prev => Math.max(prev - 0.1, 0.8)); // Min 80%
  };

  const resetTextSize = () => {
    setTextScale(1);
  };

  return (
    <AccessibilityContext.Provider value={{ textScale, increaseTextSize, decreaseTextSize, resetTextSize }}>
      {children}
    </AccessibilityContext.Provider>
  );
};